import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const revamp = config.revamp;
const accounts = "accounts/";
const account = "account/";
const dev = "dev/";
const guestlogin = "guestlogin/";
const guest = "guest/";
const otp = "otp-";
const devs = config.kambalaBase;
const devutil = "devutil/";
const LoginFlowConfigURL = {
    loginBaseUrl: config.jmw + config.jmw_login + accounts,
    loginBaseKambalaUrl: config.jmwedel + devs + config.jmw_login + account,
    loginBaseKambalaloginHelpUrl: config.jmwedel + devs + config.jmw_login + "loginhelp/",
    clientLoginValidateUser: "validateuser/",
    clientLoginValidatePassword: "validatepassword/",
    clientLoginvalidateOTP: "2falogin/",
    setPassword: "setpassword/",
    clientValidateOTP: "/forgotpassword/validateotp",
    unblockUser: "unblockuser/",
    clientForgetUserID: "forgotuserid",
    generateOTP: otp,
    mock: "https://xlyp21kxvd-vpce-035d8c7fbf6969d78.execute-api.ap-south-1.amazonaws.com/",
    guestBaseAPI: `${dev}${revamp}${guestlogin}`,
    guestRealBaseAPI: config.jmw + revamp + config.jmw_content + guest,
    accountCheck: "status",
    validateMPIN: "pin/validate",
    guestSetMPIN: "pin/register",
    checknaddEmail: "email/otp-register",
    guestverifyEmail: "email/otp-validate",
    addAccount: `${otp}register`,
    forgotPIN: "forget-mpin",
    guestValidate: `${otp}validate`,
};
export default LoginFlowConfigURL;
